import { CouponRewardType } from '@diritto/common/coupon/constants/coupon.constants';
import { EventRidiUsage } from 'app-components/events/detail/usages/EventRidiUsage';

interface EventUsageProps {
  couponRewardType: CouponRewardType;
}

export const EventUsage = ({ couponRewardType }: EventUsageProps) => {
  if (couponRewardType === CouponRewardType.RidiPointCoupon) {
    return <EventRidiUsage />;
  }

  return null;
};
